import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import classnames from 'classnames'
import { Typography, Icon, Avatar } from 'shared/ui'
import { getAriaLabel } from 'shared/lib'
import { type IUser } from 'entities/Users'
import { useEntitiesContext } from 'entities/EntitiesExport'
import styles from './styles.module.scss'

export type ICustomItemProps = {
  member: IUser
  active: boolean
  onClose: () => void
  onReassign: (id: number | null) => void
}

export const MemberItem: FC<ICustomItemProps> = observer(
  ({ member, active, onClose, onReassign }) => {
    const { usersStore } = useEntitiesContext()
    const handleReassign = async (id: number | null) => {
      if (active) return

      onClose()
      onReassign(id)
    }

    const isOwner = member.id === usersStore.user_owner_id

    return (
      <div
        className={classnames(styles.memberWrapper, {
          [styles.active]: active,
        })}
        aria-label={getAriaLabel(member.full_name)}
        onClick={() => handleReassign(member.id)}
      >
        <div className={classnames(styles.info)}>
          <Avatar info={member.avatarInfo} size={16} />
          <Typography
            className={styles.memberName}
            variant='body-md-regular'
            color='var(--content-primary-primary)'
            pointer
            ellipsis
            ariaLabel={'name'}
          >
            {member.name}
            {isOwner && ' (Assign to me)'}
          </Typography>
        </div>
        {active && <Icon icon='check1' color='var(--content-brand-primary)' />}
      </div>
    )
  }
)
